/**
 * Notifications Container Component
 *
 * Wrapper around @redfoxwp/core-components NotificationsContainer
 * that integrates with the application's notification context.
 *
 * @since 1.0.0
 */

import { NotificationsContainer as CoreNotificationsContainer } from '@redfoxwp/core-components/components/notifications-container';

import { useNotifications } from '../../hooks';

/**
 * Notifications Container component
 *
 * Displays application-wide notifications using the centralized
 * notifications context.
 *
 * @since 1.0.0
 *
 * @return JSX element.
 */
export const NotificationsContainer = (): JSX.Element => {
  const { notifications, removeNotification } = useNotifications();

  return (
    <CoreNotificationsContainer notifications={notifications} onDismiss={removeNotification} />
  );
};
